import { Typography } from "@material-ui/core";
import { Rating } from "@material-ui/lab";
import { useEffect, useState } from "react";

const ReviewStarsDynamic = ({
  size = "small",
  productId,
  showRating = false,
  yellowIcon = false,
  variant = false
}: {
  size?: "small" | "medium" | "large" | undefined;
  productId: string;
  showRating?: boolean;
  yellowIcon?: boolean;
  variant?: boolean;
}) => {
  const [data, setData] = useState<ReviewsSummary | null>(null);
  const productIdBreakdown = productId.split("/");
  const legacyProductId = productIdBreakdown[productIdBreakdown.length - 1];

  useEffect(() => {
    let isMounted = true;
    const fetchData = () => {
      try {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var payload = JSON.stringify({
          productIds: [
            {
              productId: `${legacyProductId}`
            }
          ],
          apiKey: "pubkey-UM04y4I915o7pwD35vv370t13Wiecx",
          storeUrl: "timelesslacquer.myshopify.com"
        });

        fetch(
          "https://stamped.io/api/widget/badges?isIncludeBreakdown=false&isincludehtml=false",
          {
            method: "POST",
            headers: myHeaders,
            body: payload,
            redirect: "follow"
          }
        )
          .then(response => response.json())
          .then(result => {
            if (isMounted) setData(result[0]);
          })
          .catch(error => console.log("error", error));
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  return data ? (
    <div className="review-stars-custom">
      <Rating
        className=""
        name="half-rating"
        size={"small"}
        value={data.rating}
        precision={1}
        readOnly
        icon={yellowIcon ? ratingStarFull(variant) : undefined}
        emptyIcon={yellowIcon ? ratingStarEmpty : undefined}
      />
      <Typography variant="subtitle1">
        {showRating
          ? `${data.rating.toFixed(1).replaceAll(".0", "")} out of 5`
          : `(${data.count})`}
      </Typography>
    </div>
  ) : null;
};

export default ReviewStarsDynamic;

export interface ReviewsSummary {
  productId: string;
  rating: number;
  count: number;
  countQuestions: number;
  c: boolean;
}

export const ratingStarFull = (variant: boolean) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.58058 2.69374L9.68058 4.89374C9.83058 5.19999 10.2306 5.49374 10.5681 5.54999L12.5618 5.88124C13.8368 6.09374 14.1368 7.01874 13.2181 7.93124L11.6681 9.48124C11.4056 9.74374 11.2618 10.25 11.3431 10.6125L11.7868 12.5312C12.1368 14.05 11.3306 14.6375 9.98683 13.8437L8.11808 12.7375C7.78058 12.5375 7.22433 12.5375 6.88058 12.7375L5.01183 13.8437C3.67433 14.6375 2.86183 14.0437 3.21183 12.5312L3.65558 10.6125C3.73683 10.25 3.59308 9.74374 3.33058 9.48124L1.78058 7.93124C0.868083 7.01874 1.16183 6.09374 2.43683 5.88124L4.43058 5.54999C4.76183 5.49374 5.16183 5.19999 5.31183 4.89374L6.41183 2.69374C7.01183 1.49999 7.98683 1.49999 8.58058 2.69374Z"
      fill={variant ? "#00B2A9" : "#FEE171"}
      stroke={variant ? "#00B2A9" : "#FEE171"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ratingStarEmpty = (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.58058 2.69374L9.68058 4.89374C9.83058 5.19999 10.2306 5.49374 10.5681 5.54999L12.5618 5.88124C13.8368 6.09374 14.1368 7.01874 13.2181 7.93124L11.6681 9.48124C11.4056 9.74374 11.2618 10.25 11.3431 10.6125L11.7868 12.5312C12.1368 14.05 11.3306 14.6375 9.98683 13.8437L8.11808 12.7375C7.78058 12.5375 7.22433 12.5375 6.88058 12.7375L5.01183 13.8437C3.67433 14.6375 2.86183 14.0437 3.21183 12.5312L3.65558 10.6125C3.73683 10.25 3.59308 9.74374 3.33058 9.48124L1.78058 7.93124C0.868083 7.01874 1.16183 6.09374 2.43683 5.88124L4.43058 5.54999C4.76183 5.49374 5.16183 5.19999 5.31183 4.89374L6.41183 2.69374C7.01183 1.49999 7.98683 1.49999 8.58058 2.69374Z"
      fill="#E5E5E5"
      stroke="#E5E5E5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
